import { isOnServer } from "@tm/isomorphic-utils";
import { DEVICE_MODEL_TYPE, HOST } from "@tm/types";
declare global {
  interface Window {
    getHostName: () => string;
    mmt_android_bridge?: any;
    app_bridge?: any;
    dataLayer?: any;
  }
}

export const getDeviceModelType = (): DEVICE_MODEL_TYPE | null => {
  if (isOnServer()) return null;
  if (window.mmt_android_bridge || window.app_bridge) {
    return DEVICE_MODEL_TYPE.APP;
  }
  return DEVICE_MODEL_TYPE.WEB;
};

export function getHostName() {
  if (isOnServer()) {
    return null;
  }
  if (
    typeof window !== "undefined" &&
    typeof window.getHostName === "undefined"
  ) {
    window.getHostName = () => {
      return window.location.hostname;
    };
  }
  return window?.getHostName?.() as string;
}

export function disableEncrytionInWeb() {
  return (
    getDeviceModelType() === DEVICE_MODEL_TYPE.WEB &&
    [HOST.MAKEMYTRIP, HOST.TRIPMONEY_MAKEMYTRIP].includes(getHostName() || "")
  );
}

export const isHostMakemytrip = () => {
  if (isOnServer()) return false;
  const url = new URL(window.location.href);
  return TRIPMONEY_MMT_DOMAIN_NAMES.includes(url.hostname);
};

const getGtmScript = (gtmId: string) => {
  return `(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
  new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
  j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
  'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
  })(window,document,'script','dataLayer', '${gtmId}');
  `;
};

export const loadGTM = () => {
  if (isHostMakemytrip() && typeof window !== undefined && !window?.dataLayer) {
    const script = document.createElement("script");
    script.innerHTML = getGtmScript("GTM-NWV3K7C");
    script.defer = true;
    document.head.appendChild(script);
  }
};

export function getUtilOptions(options: any) {
  return disableEncrytionInWeb() ? { ...options, isPiiData: false } : options;
}

export const TRIPMONEY_MMT_DOMAIN_NAMES = [
  "tripmoney.makemytrip.com",
  "insurance.makemytrip.com",
  "www.makemytrip.com",
];
